import React from "react";
import { TONES, statusTone, statusLabel } from "./statusMap";
import "./Badge.scss";

// Fontaine M22 — StatusDot: 8px coloured dot for list rows and kanban cards, optional text.
// Tone from the status map (pass `status`) or explicit `tone`. Never colour alone: a label or aria-label always names it.

/**
 * @param {string} [status]
 * @param {"accent"|"success"|"warning"|"danger"|"muted"|"info"} [tone]
 * @param {ReactNode} [children]     visible label (defaults to the status in sentence case)
 * @param {boolean} [pulse]          live / in-progress
 */
export default function StatusDot({ status, tone, children, pulse = false, className = "", ...rest }) {
  const resolved = status ? statusTone(status) : TONES.includes(tone) ? tone : "muted";
  const label = children ?? (status ? statusLabel(status) : null);
  const classes = ["ft-dot", `ft-dot--${resolved}`, pulse ? "is-pulse" : "", className].filter(Boolean).join(" ");
  return (
    <span className={classes} aria-label={label == null ? rest["aria-label"] || statusLabel(status) : undefined} data-status={status || undefined} {...rest}>
      <span className="ft-dot__dot" aria-hidden="true" />
      {label != null ? <span className="ft-dot__label">{label}</span> : null}
    </span>
  );
}
